<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-admi10 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-admi10>
    </div>
    }
    @if(detailVisible){
    <div class="top-1 border-1 border-green-400">
    </div>
    }
  </div>
<div>